<template>
  <component :is="getComponent()" />
</template>

<script>
export default {
  props: {
    getComponent: {
      type: Function,
      default: () => "div",
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layout/DynamicComponent.vue